<mat-sidenav-container>

  <mat-sidenav-content [ngClass]="sidenav.opened ? 'sidenav-opened':'sidenav-closed mx-0'">
    <div class="top-bar d-flex align-items-center">
      <button mat-button (click)="sidenav.toggle()" class="menu-toggle">
        <!-- <i class="fas fa-bars"></i> -->
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2">
          <rect width="18" height="18" x="3" y="3" rx="2"></rect>
          <path d="M9 3v18"></path>
        </svg>
        <span>MENU</span>
      </button>
      <mat-divider vertical class="h-50 mr-3"></mat-divider>
      <span class="current-location">{{currentPageTitle}}</span>
    </div>
    <main class="main">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>

  <mat-sidenav [mode]="(screenWidth > 992) ? 'side' : 'over'" [opened]="!screenWidth || screenWidth > 992"
    [class.sideOpened]="sidenav.opened" [class.sideClosed]="!sidenav.opened" #sidenav>

    <div class="sidenav-header">
      <a routerLink="/" class="logo-container">
        <img src="{{ logoLightUrl }}" alt="logo" class="logo">
      </a>
    </div>

    <div class="sidenav-menu">
      <div class="pt-md-3"></div>
      <!-- ADMIN USER-->
      @if (UI.isAdmin || UI.isUser || UI.isReadOnlyAdmin || UI.isReadOnlyUser) {
        <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false"
          >
          <div *csHasPermission="RolePermission.HOME_READ">
            <div *csHasNetworkPermission (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
              <a class="sidenav-menu-item" routerLink="/dashboard" routerLinkActive="active" (click)="setPageTitle('Home')">
                <!-- <i class="far fa-house"></i> -->
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="menu-icon">
                  <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                  <path d="M18 17V9"></path>
                  <path d="M13 17V5"></path>
                  <path d="M8 17v-3"></path>
                </svg>
                <span>Dashboard</span>
              </a>
            </div>
          </div>
          <div *csHasPermission="RolePermission.SUPPLY_READ">
            <mat-expansion-panel *csHasNetworkPermission class="" [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title class="sidenav-menu-item">
                  <!-- <i class="far fa-boxes"></i> -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="menu-icon">
                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                    <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
                    <path d="M3 12A9 3 0 0 0 21 12"></path>
                  </svg>
                  <span>Supply</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                <li *csHasPermission="RolePermission.SUPPLY_PUBLISHERS_READ">
                  <a routerLink="/publishers" routerLinkActive="active" (click)="setPageTitle('Publishers')">
                    <i class="fas fa-chevron-right" matTooltip="Publishers"></i>
                    <span>Publishers</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.SUPPLY_PLACEMENTS_READ">
                  <a routerLink="/placements" routerLinkActive="active" (click)="setPageTitle('Placements')">
                    <i class="fas fa-chevron-right" matTooltip="Placements"></i>
                    <span>Placements</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.SUPPLY_APPS_READ">
                  <a routerLink="/apps" routerLinkActive="active" (click)="setPageTitle('Apps')">
                    <i class="fas fa-chevron-right" matTooltip="Apps"></i>
                    <span>Apps</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.SUPPLY_APPS_READ">
                  <a routerLink="/lists" routerLinkActive="active" (click)="setPageTitle('Lists')">
                    <i class="fas fa-chevron-right" matTooltip="Lists"></i>
                    <span>Lists</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.DEMAND_COMPLIANCE_READ">
                  <a routerLinkActive="active" routerLink="/demand/compliance" (click)="setPageTitle('Domains')">
                    <i class="fas fa-chevron-right" matTooltip="Domains"></i>
                    <span>Domains</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.BLOCKLIST_CREATIVES_READ">
                  <a routerLinkActive="active" routerLink="/block-list/creatives" (click)="setPageTitle('Blocked list')">
                    <i class="fas fa-chevron-right" matTooltip="Blocked list"></i>
                    <span>Blocked list</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.TARGETING_READ">
                  <a routerLink="/tailored-supply" routerLinkActive="active" (click)="setPageTitle('Tailored Supply')">
                    <i class="fas fa-chevron-right" matTooltip="Tailored Supply"></i>
                    <span>Tailored Supply</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.SUPPLY_ADS_TXT_READ">
                  <a routerLinkActive="active" routerLink="/ads-txt" (click)="setPageTitle('Ads.txt')">
                    <i class="fas fa-chevron-right" matTooltip="Ads.txt"></i>
                    <span>Ads.txt</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.SUPPLY_ENDPOINT_GENERATOR_READ">
                  <a routerLinkActive="active" routerLink="/endpoint-generator" (click)="setPageTitle('Endpoint generator')">
                    <i class="fas fa-chevron-right" matTooltip="Endpoint generator"></i>
                    <span>Endpoint generator</span>
                  </a>
                </li>
              </ul>
            </mat-expansion-panel>
          </div>
          <div *csHasPermission="RolePermission.DEMAND_READ">
            <mat-expansion-panel *csHasNetworkPermission class="" [expanded]="false">
              <mat-expansion-panel-header>
                <mat-panel-title class="sidenav-menu-item">
                  <!-- <i class="far fa-user-visor"></i> -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="menu-icon">
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="12" r="6"></circle>
                    <circle cx="12" cy="12" r="2"></circle>
                  </svg>
                  Demand
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                @if (environment.customFlag === 'altentiv') {
                  <li *csHasPermission="RolePermission.DEMAND_PARTNERS_READ">
                    <a routerLinkActive="active" routerLink="/demand/owners" (click)="setPageTitle('Owners')">
                      <i class="fas fa-chevron-right" matTooltip="Owners"></i>
                      <span>Owners</span>
                    </a>
                  </li>
                }
                <li *csHasPermission="RolePermission.DEMAND_PARTNERS_READ">
                  <a routerLinkActive="active" routerLink="/demand/list" (click)="setPageTitle('Partners')">
                    <i class="fas fa-chevron-right" matTooltip="Partners"></i>
                    <span>Partners</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.DEMAND_CONNECTIONS_READ">
                  <a routerLinkActive="active" routerLink="/integrations" (click)="setPageTitle('Integrations')">
                    <i class="fas fa-chevron-right" matTooltip="Demand Integrations"></i>
                    <span>Integrations</span>
                  </a>
                </li>
                <li *csHasPermission="RolePermission.DEMAND_DEALS_READ">
                  <a routerLinkActive="active" routerLink="/deals" (click)="setPageTitle('Deals')">
                    <i class="fas fa-chevron-right" matTooltip="Deals"></i>
                    <span>Deals</span>
                  </a>
                </li>
                <!-- <li *csHasPermission="RolePermission.DEMAND_DISCREPANCIES_READ">
                <a routerLinkActive="active" routerLink="/demand/discrepancies">
                  <i class="fas fa-chevron-right" matTooltip="Discrepancies"></i>
                  <span>Discrepancies</span>
                </a>
              </li> -->
            </ul>
          </mat-expansion-panel>
        </div>
        @if (environment.customFlag === 'ba' || environment.customFlag === 'dx' || environment.customFlag === 'pwr-ads' ||
         environment.customFlag === 'emtvssp' || environment.customFlag === 'demo' || environment.customFlag === 'altentiv' || environment.customFlag === 'oveeo') {
          <div *csHasPermission="RolePermission.MADBUY_CAMPAIGN_READ">
            @if (isFeatureAllowed(NetworkAvailableFeatures.CAMPAIGN)) {
              <div>
                <mat-expansion-panel class="" *csHasNetworkPermission [expanded]="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="sidenav-menu-item">
                      <!-- <i class="far fa-chart-network"></i> -->
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="menu-icon">
                        <path d="M8 2v4"></path>
                        <path d="M16 2v4"></path>
                        <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                        <path d="M3 10h18"></path>
                      </svg>
                      Campaigns
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
                    <li *csHasPermission="RolePermission.MADBUY_CAMPAIGN_READ">
                      <a routerLink="/campaigns/brands" routerLinkActive="active" (click)="setPageTitle('Brands')">
                        <i class="fas fa-chevron-right" matTooltip="Brands"></i>
                        <span>Brands</span>
                      </a>
                    </li>
                    <li *csHasPermission="RolePermission.MADBUY_SUPPLY_READ">
                      <a routerLink="/campaigns/supply/apps" routerLinkActive="active" (click)="setPageTitle('Supply')">
                        <i class="fas fa-chevron-right" matTooltip="Supply"></i>
                        <span>Supply</span>
                      </a>
                    </li>
                    <li *csHasPermission="RolePermission.MADBUY_SUPPLY_READ">
                      <a routerLink="/campaigns/channel-groups" routerLinkActive="active" (click)="setPageTitle('Channel Groups')">
                        <i class="fas fa-chevron-right" matTooltip="Channel Groups"></i>
                        <span>Channel Groups</span>
                      </a>
                    </li>
                    <li *csHasPermission="RolePermission.MADBUY_CAMPAIGN_READ">
                      <a routerLink="/campaigns/campaigns" routerLinkActive="active" (click)="setPageTitle('Campaigns')">
                        <i class="fas fa-chevron-right" matTooltip="Campaigns"></i>
                        <span>Campaigns</span>
                      </a>
                    </li>
                    <li *csHasPermission="RolePermission.MADBUY_CREATIVES_READ">
                      <a routerLink="/campaigns/creatives" routerLinkActive="active" (click)="setPageTitle('Creatives')">
                        <i class="fas fa-chevron-right" matTooltip="Creatives"></i>
                        <span>Creatives</span>
                      </a>
                    </li>
                    <!-- <li *csHasPermission="RolePermission.CAMPAIGNS_ORDERS_READ">
                    <a routerLink="/orders" routerLinkActive="active" (click)="setPageTitle('Orders')">
                      <i class="fas fa-chevron-right" matTooltip="Orders"></i>
                      <span>Orders</span>
                    </a>
                  </li>
                  <li *csHasPermission="RolePermission.CAMPAIGNS_LINE_ITEMS_READ">
                    <a routerLinkActive="active" routerLink="/line-items/table" (click)="setPageTitle('Line Items')">
                      <i class="fas fa-chevron-right" matTooltip="Line Items"></i>
                      <span>Line Items</span>
                    </a>
                  </li>
                  <li *csHasPermission="RolePermission.CAMPAIGNS_CREATIVE_READ">
                    <a [routerLink]="['/', AppRoutePath.CAMPAIGNS, AppRoutePath.CAMPAIGNS_CREATIVE_LIBRARY]"
                      routerLinkActive="active" (click)="setPageTitle('Creatives')">
                      <i class="fas fa-chevron-right" matTooltip="Creatives"></i>
                      <span>Creatives</span>
                    </a>
                  </li> -->
                </ul>
              </mat-expansion-panel>
            </div>
          }
        </div>
      }
      <div *csHasPermission="RolePermission.REPORTING_READ">
        <mat-expansion-panel class="" [expanded]="false" *csHasNetworkPermission>
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <!-- <i class="far fa-chart-bar"></i> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="menu-icon">
                <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                <path d="m19 9-5 5-4-4-3 3"></path>
              </svg>
              Reporting
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li *csHasPermission="RolePermission.REPORTING_REPORT_BUILDER_READ">
              <a routerLink="/reports" routerLinkActive="active" (click)="setPageTitle('Report Builder')">
                <i class="fas fa-chevron-right" matTooltip="Report Builder"></i>
                <span>Report Builder</span>
              </a>
            </li>
            <li *csHasPermission="RolePermission.REPORTING_PERFORMANCE_READ">
              <a routerLink="/performance" routerLinkActive="active" (click)="setPageTitle('Performance')">
                <i class="fas fa-chevron-right" matTooltip="Performance"></i>
                <span>Performance</span>
              </a>
            </li>
            <li *csHasPermission="RolePermission.REPORTING_SCHEDULED_REPORTS_READ">
              <a routerLink="/scheduled-reports" routerLinkActive="active"
                *csHasPermission="RolePermission.RB_SCHEDULE_CREATE" (click)="setPageTitle('Saved reports')">
                <i class="fas fa-chevron-right" matTooltip="Saved reports"></i>
                <span>Saved reports</span>
              </a>
            </li>
            <!-- Section was removed during the refactor 5.1.2024. module errors removed, path to module removed -->
            <!-- <li *csHasPermission="RolePermission.REPORTING_ERROR_REPORTS_READ">
            <a [routerLink]="['/', AppRoutePath.ERRORS]" routerLinkActive="active">
              <i class="fas fa-circle" matTooltip="Errors"></i>
              <span>Error Reports</span>
            </a>
          </li> -->
        </ul>
      </mat-expansion-panel>
    </div>
    <div *csHasPermission="RolePermission.A2V_READ">
      @if (isFeatureAllowed(NetworkAvailableFeatures.A2V)) {
        <div>
          <mat-expansion-panel *csHasNetworkPermission class="" [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title class="sidenav-menu-item">
                <i class="fal fa-tv-music" matTooltip="Audio to Video"></i>
                <span>A2V</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
              <li *csHasPermission="RolePermission.A2V_ASSETS_READ">
                <a routerLink="/assets" routerLinkActive="active" (click)="setPageTitle('Assets')">
                  <i class="fas fa-chevron-right" matTooltip="Assets"></i>
                  <span>Assets</span>
                </a>
              </li>
              <li *csHasPermission="RolePermission.A2V_BRANDS_READ" [hidden]="true">
                <a routerLink="/brands" routerLinkActive="active" (click)="setPageTitle('Brands')">
                  <i class="fas fa-chevron-right" matTooltip="Brands"></i>
                  <span>Brands</span>
                </a>
              </li>
              <li *csHasPermission="RolePermission.A2V_NETWORK_TEMPLATE_READ">
                <a routerLink="/network-template" routerLinkActive="active" (click)="setPageTitle('Network template')">
                  <i class="fas fa-chevron-right" matTooltip="Network template"></i>
                  <span>Network template</span>
                </a>
              </li>
            </ul>
          </mat-expansion-panel>
        </div>
      }
    </div>
    <div *csHasPermission="RolePermission.TARGETING_READ">
      <mat-expansion-panel class="" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title class="sidenav-menu-item">
            <!-- <i class="far fa-bullseye" matTooltip="Targeting"></i> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="menu-icon">
              <circle cx="12" cy="12" r="10"></circle>
              <circle cx="12" cy="12" r="6"></circle>
              <circle cx="12" cy="12" r="2"></circle>
            </svg>
            Targeting
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
          <li *csHasPermission="RolePermission.TARGETING_READ">
            <a [routerLink]="['/', AppRoutePath.TARGETING]" routerLinkActive="active" (click)="setPageTitle('Targeting Builder')">
              <i class="fas fa-chevron-right" matTooltip="Collections"></i>
              <span>Targeting Builder</span>
            </a>
          </li>
          <li *csHasPermission="RolePermission.FORECAST_READ">
            <a routerLink="/forecast" routerLinkActive="active" (click)="setPageTitle('Forecast')">
              <i class="fas fa-chevron-right" matTooltip="Forecast"></i>
              <span>Forecast</span>
            </a>
          </li>
        </ul>
      </mat-expansion-panel>
    </div>
    <!-- <div *csHasPermission="RolePermission.TARGETING_READ"
    (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
    <a class="sidenav-menu-item" [routerLink]="['/', AppRoutePath.TARGETING]" routerLinkActive="active"
      (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
      <i class="far fa-bullseye" matTooltip="Targeting"></i>
      <span>Targeting</span>
    </a>
  </div>
  <div *csHasPermission="RolePermission.FORECAST_READ"
    (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
    <a class="sidenav-menu-item" routerLink="/forecast" routerLinkActive="active"
      (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
      <i class="fa-regular fa-chart-simple" matTooltip="Forecast"></i>
      <span>Forecast</span>
    </a>
  </div> -->
  <div *csHasPermission="RolePermission.CONTENT_READ">
    @if (isFeatureAllowed(NetworkAvailableFeatures.CONTENT)) {
      <div>
        <mat-expansion-panel class="" [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title class="sidenav-menu-item">
              <i class="far fa-books"></i>
              Content
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
            <li *csHasPermission="RolePermission.CONTENT_COLLECTIONS_READ">
              <a routerLink="/collections" routerLinkActive="active" (click)="setPageTitle('Collections')">
                <i class="fas fa-chevron-right" matTooltip="Collections"></i>
                <span>Collections</span>
              </a>
            </li>
            <li *csHasPermission="RolePermission.CONTENT_VIDEOS_READ">
              <a routerLink="/videos" routerLinkActive="active" (click)="setPageTitle('Videos')">
                <i class="fas fa-chevron-right" matTooltip="Videos"></i>
                <span>Videos</span>
              </a>
            </li>
            @if (environment.customFlag === 'altentiv') {
              <li *csHasPermission="RolePermission.CONTENT_CONTENT_OWNERS_READ">
                <a routerLinkActive="active" routerLink="/content-owner" (click)="setPageTitle('Content owners')">
                  <i class="fas fa-chevron-right" matTooltip="Content owners"></i>
                  <span>Content owners</span>
                </a>
              </li>
            }
          </ul>
        </mat-expansion-panel>
      </div>
    }
  </div>
  <!-- <div *ngIf="isFeatureAllowed(NetworkAvailableFeatures.CAMPAIGN)">
  <ng-container *csHasPermission="RolePermission.WIDGET_TYPES_READ">
    <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
      <a class="sidenav-menu-item " routerLink="/widget-types" routerLinkActive="active"
        (click)="closeSidenavMobile(sidenav); closeAllNetworkExpansionsPanels();">
        <i class="fal fa-magic" matTooltip="Widget types"></i>
        <span>Widget types</span>
      </a>
    </div>
  </ng-container>
</div> -->
<!-- <div *csHasPermission="RolePermission.AI_WEB_PLAYER_READ">
<mat-expansion-panel class="" [expanded]="false">
  <mat-expansion-panel-header>
    <mat-panel-title class="sidenav-menu-item">
      <i class="far fa-robot"></i>
      AI Web Player
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
    <li *csHasPermission="RolePermission.AI_WEB_PLAYER_DOMAINS_READ">
      <a routerLink="/ai-web-player" routerLinkActive="active">
        <i class="fas fa-chevron-right" matTooltip="Domains"></i>
        <span>Domains</span>
      </a>
    </li>
  </ul>
</mat-expansion-panel>
</div> -->
<div *csHasPermission="RolePermission.ADMIN_READ">
  <mat-expansion-panel class="" [expanded]="false">
    <mat-expansion-panel-header>
      <mat-panel-title class="sidenav-menu-item">
        <i class="far fa-tools"></i>
        Admin
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
      <li *csHasPermission="RolePermission.USERS_USERS_READ">
        <a routerLink="/users" routerLinkActive="active" (click)="setPageTitle('Users')">
          <i class="fas fa-chevron-right" matTooltip="Users"></i>
          <span>Users</span>
        </a>
      </li>
      <!-- <li *csHasPermission="RolePermission.USERS_ROLES_READ">
      <a routerLink="/roles" routerLinkActive="active">
        <i class="fas fa-chevron-right" matTooltip="Roles"></i>
        <span>Roles</span>
      </a>
    </li> -->
    <li *csHasPermission="RolePermission.CHANGELOG_READ">
      <a routerLink="/changelog" routerLinkActive="active" (click)="setPageTitle('Changelog')">
        <i class="fas fa-chevron-right" matTooltip="Changelog"></i>
        <span>Changelog</span>
      </a>
    </li>
  </ul>
</mat-expansion-panel>
</div>
@if (UI.isAdmin || UI.isReadOnlyAdmin) {
  <div *csHasPermission="RolePermission.DEBUG_READ">
    <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
      <a class="sidenav-menu-item" routerLink="/debug" routerLinkActive="active" (click)="setPageTitle('Debug')">
        <i class="fas fa-bug"></i>
        <span>Debug</span>
      </a>
    </div>
  </div>
}
</mat-accordion>
}
<!-- ADMIN USER END-->

<!--SUPER ADMIN USER START-->
@if (UI.isSuperAdmin) {
  <mat-accordion class="app-nav-accordion" #accordion="matAccordion" [multi]="false">
    <div *csHasPermission="RolePermission.HOME_READ">
      <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
        <a class="sidenav-menu-item" routerLink="/dashboard" routerLinkActive="active" (click)="setPageTitle('Home')">
          <!-- <i class="far fa-house"></i> -->
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="menu-icon">
            <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
            <path d="M18 17V9"></path>
            <path d="M13 17V5"></path>
            <path d="M8 17v-3"></path>
          </svg>
          <span>Dashboard</span>
        </a>
      </div>
    </div>
    <div *csHasPermission="RolePermission.HOME_READ">
      <div (click)="closeSidenavMobile(sidenav); closeAllExpansionsPanels();">
        <a class="sidenav-menu-item" routerLink="/networks" routerLinkActive="active" (click)="setPageTitle('Networks')">
          <i class="fa-regular fa-network-wired"></i>
          <span>Networks</span>
        </a>
      </div>
    </div>
    <!-- <div *csHasPermission="RolePermission.AI_WEB_PLAYER_READ">
    <mat-expansion-panel class="" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title class="sidenav-menu-item">
          <i class="far fa-robot"></i>
          AI Web Player
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
        <li *csHasPermission="RolePermission.AI_WEB_PLAYER_DOMAINS_READ">
          <a routerLink="/ai-web-player" routerLinkActive="active" (click)="setPageTitle('AI Web Player')">
            <i class="fas fa-chevron-right" matTooltip="Domains"></i>
            <span>Domains</span>
          </a>
        </li>
      </ul>
    </mat-expansion-panel>
  </div> -->
  <div *csHasPermission="RolePermission.REPORTING_READ">
    <mat-expansion-panel class="" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title class="sidenav-menu-item">
          <!-- <i class="far fa-chart-bar"></i> -->
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="menu-icon">
            <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
            <path d="m19 9-5 5-4-4-3 3"></path>
          </svg>
          Reporting
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
        <li *csHasPermission="RolePermission.REPORTING_REPORT_BUILDER_READ">
          <a routerLink="/reports" routerLinkActive="active" (click)="setPageTitle('Report Builder')">
            <i class="fas fa-chevron-right" matTooltip="Report Builder"></i>
            <span>Report Builder</span>
          </a>
        </li>
        <li *csHasPermission="RolePermission.REPORTING_READ">
          <a routerLink="/network-performance" routerLinkActive="active" (click)="setPageTitle('Network Performance')">
            <i class="fas fa-chevron-right" matTooltip="Network Performance"></i>
            <span>Network Performance</span>
          </a>
        </li>
      </ul>
    </mat-expansion-panel>
  </div>
  <div *csHasPermission="RolePermission.ADMIN_READ">
    <mat-expansion-panel class="" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title class="sidenav-menu-item">
          <i class="far fa-tools"></i>
          Admin
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul class="sidenav-submenu" (click)="closeSidenavMobile(sidenav)">
        <li *csHasPermission="RolePermission.USERS_USERS_READ">
          <a routerLink="/users" routerLinkActive="active" (click)="setPageTitle('Users')">
            <i class="fas fa-chevron-right" matTooltip="Users"></i>
            <span>Users</span>
          </a>
        </li>
      </ul>
    </mat-expansion-panel>
  </div>
</mat-accordion>
}

</div>

<div class="sidenav-footer">
  <button mat-button [matMenuTriggerFor]="menu" class="user-menu-button">
    <div class="user-info">
      <mat-icon>person</mat-icon>
      <span class="user-name">{{user?.name}}</span>
    </div>
    <!-- <mat-icon class="menu-icon">more_vert</mat-icon> -->
  </button>
  <mat-menu #menu="matMenu" class="user-dropdown-menu">
    <div *csHasPermission="RolePermission.PUBLISHER_DASHBOARD_READ">
      @for (pub of publishers; track pub) {
        <button mat-menu-item (click)="openDashboard('publisher', pub.id)">
          <i class="far fa-fw fa-house-user"></i>
          <span class="ml-2">{{pub.name}}</span>
        </button>
      }
    </div>
    <div *csHasPermission="RolePermission.ADVERTISER_READ">
      @if (user?.advertiserId) {
        <button mat-menu-item (click)="openDashboard('advertiser', advertiser?.id)">
          <i class="fa fa-users"></i>
          <span class="ml-2">{{advertiser?.name}}</span>
        </button>
      }
    </div>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()" class="sign-out-button">
      <i class="far fa-fw fa-sign-out text-danger"></i>
      <span class="ml-2 text-danger">Sign out</span>
    </button>
  </mat-menu>
</div>

</mat-sidenav>
</mat-sidenav-container>
